import VueRouter from 'vue-router';
import Home from 'pages/Home';
import About from 'pages/About';
import Careers from 'pages/Careers';
import Contact from 'pages/Contact';
import Portfolio from 'pages/Portfolio';
import PageNotFound from 'pages/PageNotFound';
import ProjectDetail from 'pages/ProjectDetail';

const routes = [
  {
    path:      '/',
    name:      'Label Interactive',
    component: Home,
  },
  {
    path:      '/about',
    name:      'About',
    component: About,
  },
  {
    path:      '/careers',
    name:      'Careers',
    component: Careers,
  },
  {
    path:      '/contact',
    name:      'Contact',
    component: Contact,
  },
  {
    path:      '/portfolio',
    name:      'Portfolio',
    component: Portfolio,
  },
  {
    path:      '/portfolio/:slug',
    name:      'Project Detail',
    component: ProjectDetail,
  },
  {
    path:      '*',
    name:      '404',
    component: PageNotFound,
  },
];

let config = { routes };

if (process.env.NODE_ENV === 'production') {
  config = { ...config, mode: 'history', base: process.env.BASE_PATH };
}

export default new VueRouter(config);



// WEBPACK FOOTER //
// ./src/services/Routing.js